import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core'
import { RouterLink } from '@angular/router'

import { UIModule } from '@app/modules/ui/ui.module'
import { iOS } from '@app/utils'

@Component({
  selector: 'sb-voice-message-creator-mic-access-required',
  templateUrl: './voice-message-creator-mic-access-required.component.html',
  imports: [UIModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageCreatorMicAccessRequiredComponent {
  @Input() showCheckBrowser = false

  exit = output<void>()

  readonly checkBrowserInfo = `Having trouble?
    ${iOS ? 'Make sure your device is up to date and try Safari.' : 'Try the latest version of Google Chrome.'}`
}
